import _ from "lodash";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useRecommendationsFetch } from "../../lib/api";
import { useSearchQuery } from "../../lib/custom_hooks";
import Sidebar from "../Sidebar";
import ExternalLink from "../common/ExternalLink";
import FakeSpinner from "../common/FakeLoader";
import FilterTags from "../common/FilterTags";
import Search from "../common/Search";
import RecommendationGroupsList from "../recommendation/RecommendationGroupsList";

const RecommendationsPage = ({ searchMode }) => {
  const initialSearchQuery = useSearchQuery();
  const { t } = useTranslation();

  const { currentFilters, data, isError, isLoading, onChangeFilter, onClearFilters } =
    useRecommendationsFetch("recommendations", { searchMode });

  const onRemoveFilter = useCallback(
    (filterKey) => {
      onChangeFilter(filterKey, "any");
    },
    [onChangeFilter]
  );

  return (
    <>
      <div className="bg-gray-100 overflow-hidden relative font-transat">
        <div
          className="relative
          h-full w-full overflow-hidden flex flex-col-reverse sm:flex-row justify-end"
        >
          <div className="w-full">
            <div
              id="search-and-tags-container"
              className="w-full relative tailwind-hidden md:block md:mt-15 lg:mt-0"
              style={{ zIndex: 5 }}
            >
              <div className="w-full  max-w-screen-lg mx-auto flex flex-col md:flex-row items-center">
                <Search
                  className="mt-8 mx-3 md:mt-1 mb-2"
                  searchQuery={initialSearchQuery}
                  onSearch={(query) => onChangeFilter("searchQuery", query)}
                />
                <div className="mt-2 flex flex-col md:flex-row">
                  <Link className="my-auto mx-3 text-red-200" to="/glossary">
                    {t("labels.glossary")}
                  </Link>
                  <ExternalLink className="my-auto mx-3 text-red-200" url={t("links.guidelines")}>
                    {t("labels.good_practises")}
                  </ExternalLink>
                </div>
              </div>
              <FilterTags currentFilters={currentFilters} onRemove={onRemoveFilter} />
            </div>
            <div className="flex-grow w-full max-w-screen-lg mx-auto mt-8 md:mt-0">
              {isError && <div>{t("errors.fetching_failed")}</div>}
              <FakeSpinner isLoading={isLoading} interval={75} />
              {!isLoading && <RecommendationGroupsList recommendations={data?.recommendations} />}
            </div>
          </div>
          {isLoading || _.isEmpty(data) ? null : (
            <Sidebar
              isLoading={isLoading}
              filters={data.filterValues}
              currentFilters={currentFilters}
              onChangeFilter={onChangeFilter}
              onClearFilters={onClearFilters}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default RecommendationsPage;
